import { styled } from '@material-ui/core';
import { Select , Space } from 'antd';
import React from 'react'
import { useTranslation } from 'react-i18next';
import TextField from '../TextField';
import { countries, shortMonthYearFormat } from '../../helpers/AppHelpers';
import DatePicker from '../DatePicker';
import AutoComplete from '../AutoComplete';
import Checkbox from '../Checkbox';
import { InfoTooltip } from '../Tooltips/InfoTooltip';

const QualificationForm = ({ item, onChange, identifier = '', errors, setErrors, isDisabled = false, keySkillList, type, tooltipType }) => {
  const { t } = useTranslation('leftSidebar');

  return (
    <div>
      <TextField
        className="mb-6"
        label={t('qualifications.type.label')}
        placeholder={t('qualifications.type.placeholder')}
        value={isDisabled ? type : item.type}
        star="true"
        validation={errors.key}
        onChange={(v) => {
          onChange(`${identifier}type`, v);
          setErrors({
            key: false,
            issued: errors.issued,
            start: errors.start,
            country: errors.country,
          });
        }}
        tooltip="right"
        tooltipType={tooltipType}
        tooltipLabel={t('qualifications.type.label')}
        disabled={isDisabled}
      />
      <TextField
        className="mb-6"
        label={t('qualifications.name.label')}
        placeholder={t('qualifications.name.placeholder')}
        value={item.key}
        star="true"
        validation={errors.key}
        onChange={(v) => {
          onChange(`${identifier}key`, v);
          setErrors({
            key: false,
            issued: errors.issued,
            start: errors.start,
            country: errors.country,
          });
        }}
        tooltip="right"
        tooltipType="certifications"
        tooltipLabel={t('certifications.key.label')}
        disabled={isDisabled}
      />

      <TextField
        className="mb-6"
        label={t('qualifications.link.label')}
        placeholder={t('qualifications.link.placeholder')}
        value={item.link}
        onChange={(v) => {
          onChange(`${identifier}link`, v);
        }}
        tooltip="right"
        tooltipType={tooltipType}
        tooltipLabel={t('qualifications.link.label')}
        disabled={isDisabled}
      />

      <TextField
        className="mb-6"
        label={t('qualifications.issued.label')}
        placeholder={t('qualifications.issued.placeholder')}
        value={item.issued}
        star="true"
        validation={errors.issued}
        onChange={(v) => {
          onChange(`${identifier}issued`, v);
          setErrors({
            key: errors.key,
            issued: false,
            start: errors.start,
            country: errors.country,
          });
        }}
        tooltip="right"
        tooltipType={tooltipType}
        tooltipLabel={t('qualifications.issued.label')}
        disabled={isDisabled}
      />

      <div className="flex items-center gap-2 mb-6">
        <Checkbox
          checked={item.isStateAccredited}
          onChange={(v) => onChange(`${identifier}isStateAccredited`, v)}
          disabled={isDisabled}
        />
        <div className={isDisabled ? 'opacity-50 cursor-not-allowed user-select-none' : ''}>{t('qualifications.state.label')}</div>
      </div>

      {item.isStateAccredited && (
        <AutoComplete
          label={t('qualifications.state.dropdownLabel')}
          value={item.country}
          options={countries.map((country) => country.value)}
          error={errors.country}
          onChange={(v) => {
            onChange(`${identifier}country`, v || '');
            setErrors({
              key: errors.key,
              issued: errors.issued,
              start: errors.start,
              country: false,
            });
          }}
          getOptionLabel={(option) => option}
          disabled={isDisabled}
        />
      )}

      <div className="grid grid-cols-2 col-gap-4 mb-6">
        <DatePicker
          name={`${t('qualifications.start_date.label')}*`}
          value={item.start}
          onChange={(v) => {
            onChange(`${identifier}start`, v);
            setErrors({
              key: errors.key,
              issued: errors.issued,
              start: false,
              country: errors.country,
            });
          }}
          clickResetDate={() => !isDisabled && onChange(`${identifier}start`, null)}
          // validationMessage={errors.start}
          views={['year', 'month']}
          format={shortMonthYearFormat}
          tooltip="right"
          tooltipType={tooltipType}
          tooltipLabel={t('qualifications.start_date.label')}
          disableFuture={false}
          disabled={isDisabled}
        />
        <DatePicker
          name={t('qualifications.end_date.label')}
          value={item.end}
          onChange={(v) => onChange(`${identifier}end`, v)}
          clickResetDate={() => !isDisabled && onChange(`${identifier}end`, null)}
          // validationMessage={errors?.end}
          views={['year', 'month']}
          format={shortMonthYearFormat}
          tooltip="right"
          tooltipType={tooltipType}
          tooltipLabel={t('qualifications.end_date.label')}
          disableFuture={false}
          disabled={isDisabled}
        />
      </div>
      <Space size="small" direction="vertical" className="w-full mb-6">
        <label className="uppercase tracking-wide text-gray-600 text-xs font-semibold mb-2">
          <div className="flex flex-row gap-2 items-center">
            {t('qualifications.tags.label')}
            <InfoTooltip
              placement="right"
              data="certifications"
              label={t('qualifications.tags.label')}
            />
          </div>
        </label>
        <CustomSelect
          className="w-full"
          mode="multiple"
          labelInValue
          allowClear
          placeholder={t('qualifications.tags.placeholder')}
          options={keySkillList.map((keySkill) => ({ value: keySkill.title }))}
          onChange={(v) => onChange(`${identifier}tags`, v)}
          value={item.tags}
          disabled={isDisabled}
        />
      </Space>
    </div>
  )
}

export default QualificationForm

const CustomSelect = styled(Select)({
  '& .ant-select-open': {
    border: '1px solid #000000 !important',
    display: 'none !important',
  },
  '& .ant-select-selector': {
    minHeight: '42px !important',
    backgroundColor: '#EDF2F7 !important',
    border: '1px solid transparent !important',
  },
  '& .ant-select-selection-item': {
    backgroundColor: '#FFFFFF !important',
  },
});
